module.exports = __webpack_public_path__ + "img/_rating_star.65ad36fa.svg";